import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import { default as __ } from '../../utils';
import AvatarCustomize from './avatar';
import PalaCustomize from './pala';
import LevelBar from './level';
import Sidebar from '../../components/ui/sidebar';
import LogOut from './logout';
import { useUser } from '../../context/user';
import ScrollToTopOnMount from '../../components/utils/scroll-top';
import BackLink from '../../components/utils/back-link';
import { default as API } from '../../api';
import { default as UI_ACTIONS } from '../../reducers/ui';
import { default as SESSION_ACTIONS } from '../../reducers/session';

const ConnectedProfile = props => {
  const { notifyUser, tryChangeLevel, user } = props;
  const { userOnline } = useUser();
  let { sessionId } = user;
  let variant = props.location.state.show;

  let saveNewLevel = newLevel => {
    API.updateKey(sessionId, 'level', newLevel)
      .then(_ =>
        __.callAll(tryChangeLevel(newLevel), notifyUser('', false, 'success')),
      )
      .catch(o_O => notifyUser(o_O.code, 'sticky', 'fail'));
  };

  return (
    <>
      <ScrollToTopOnMount />
      <Sidebar>
        <BackLink />
        <LogOut />
      </Sidebar>
      <main>
        <section>
          {!variant && (
            <div className="owl">
              <LevelBar level={user.level} cb={saveNewLevel} />
              <AvatarCustomize />
              <PalaCustomize />
            </div>
          )}
          {variant === 'level' && (
            <LevelBar level={user.level} cb={saveNewLevel} />
          )}
          {variant === 'pala' && <PalaCustomize />}
          {variant === 'avatar' && <AvatarCustomize />}
        </section>
      </main>
    </>
  );
};

const select = state => {
  return {
    user: state.session.user,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    notifyUser: (msg, sticky, icon) =>
      dispatch(UI_ACTIONS.showFeedback(msg, sticky, icon)),
    tryChangeLevel: level => dispatch(SESSION_ACTIONS.changeLevel(level)),
  };
};

const Profile = connect(select, mapDispatchToProps)(ConnectedProfile);

export default Profile;
